import { Add, Close, Edit, SwipeUp } from '@mui/icons-material';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Form, Spin } from 'antd';
import ButtonMui from '@mui/material/Button';
import Billetage from '../../../Billetage';
import InputForm from '../../../InputT';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import Data from "../../../../Data/Data.json";
import Tab1 from '../../GarantieManage/Tab1';
import GarantieManage from '../../GarantieManage/Garantie';

export default function NewGarantie(props: { adherant?: any, label?: string, title?: string, form?: any, data?: any, onFinish: any }) {
    const [open, setOpen] = React.useState(false);
    const [isOk, setIsOk] = useState<boolean>(false)
    const { register, handleSubmit } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [loading, setLoading] = useState<boolean>(false)

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <Button style={{ marginTop: "7%" }} disabled={false} className='bt_add' type='ghost' color='success' onClick={handleClickOpen}>Gestion de Garantie</Button>

            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Dialog style={{ zIndex: 1, width: "80%", marginLeft: "17%", marginTop: "3%" }} maxWidth={false} fullWidth open={open} onClose={handleClose} aria-labelledby="form-dialog-title">

                    <ButtonMui variant='outlined' style={{ boxShadow: "none", width: "50px", left: "95%"}} color='error' size='small' onClick={handleClose} ><Close /></ButtonMui>
                    <DialogContent style={{ height: "700px" }}>
                        <GarantieManage isButton />
                    </DialogContent>
                </Dialog>
            </Spin>
        </div>
    );
}
